import {PayloadAction, createSlice} from '@reduxjs/toolkit'
import {ExamState, FetchExamsResponse, FetchExamByIdResponse, FetchAllExamsResponse} from './types'
import {
  fetchExamById,
  fetchExams,
  createExam,
  updateExam,
  deleteExam,
  endExam,
  undoExam,
  fetchAllExams,
} from './service'
import {ResponseError} from '../commonTypes'

const initialState: ExamState = {
  examForEdit: null,
  exams: [],
  total: 0,
  totalPages: 0,
  listLoading: false,
  actionLoading: false,
  error: null,
}
const examSlice = createSlice({
  name: 'exam',
  initialState,
  reducers: {
    resetExams: (state: ExamState) => {
      state.exams = []
      state.total = 0
      state.totalPages = 0
    },
  },
  extraReducers: (builder) => {
    builder.addCase(fetchExams.pending, (state: ExamState) => {
      state.listLoading = true
      state.error = null
    })
    builder.addCase(fetchExams.rejected, (state: ExamState, action: PayloadAction<any>) => {
      const {error} = action.payload
      state.error = error
      state.listLoading = false
    })
    builder.addCase(
      fetchExams.fulfilled,
      (state: ExamState, action: PayloadAction<FetchExamsResponse>) => {
        state.listLoading = false
        state.error = null
        const {exams, total, totalPages} = action.payload
        state.exams = exams
        state.total = total
        state.totalPages = totalPages
      }
    )

    builder.addCase(fetchAllExams.pending, (state: ExamState) => {
      state.listLoading = true
      state.error = null
    })
    builder.addCase(fetchAllExams.rejected, (state: ExamState, action: PayloadAction<any>) => {
      const {error} = action.payload
      state.error = error
      state.listLoading = false
    })
    builder.addCase(
      fetchAllExams.fulfilled,
      (state: ExamState, action: PayloadAction<FetchAllExamsResponse>) => {
        state.listLoading = false
        state.error = null
        const {exams} = action.payload
        state.exams = exams
      }
    )

    builder.addCase(fetchExamById.pending, (state: ExamState) => {
      state.listLoading = true
      state.error = null
    })
    builder.addCase(fetchExamById.rejected, (state: ExamState, action: PayloadAction<any>) => {
      const {error} = action.payload
      state.error = error
      state.listLoading = false
    })
    builder.addCase(
      fetchExamById.fulfilled,
      (state: ExamState, action: PayloadAction<FetchExamByIdResponse>) => {
        state.examForEdit = action.payload.exam
        state.listLoading = false
        state.error = null
        state.examForEdit = action.payload.exam
      }
    )

    builder.addCase(createExam.pending, (state: ExamState) => {
      state.actionLoading = true
      state.error = null
    })
    builder.addCase(createExam.rejected, (state: ExamState, action: PayloadAction<any>) => {
      const {error} = action.payload
      state.error = error
      state.actionLoading = false
    })
    builder.addCase(
      createExam.fulfilled,
      (state: ExamState, action: PayloadAction<FetchExamByIdResponse>) => {
        state.examForEdit = action.payload.exam
        state.actionLoading = false
        state.error = null
      }
    )

    builder.addCase(updateExam.pending, (state: ExamState) => {
      state.actionLoading = true
      state.error = null
    })
    builder.addCase(updateExam.rejected, (state: ExamState, action: PayloadAction<any>) => {
      const {error} = action.payload
      state.error = error
      state.actionLoading = false
    })
    builder.addCase(
      updateExam.fulfilled,
      (state: ExamState, action: PayloadAction<FetchExamByIdResponse>) => {
        state.examForEdit = action.payload.exam
        state.actionLoading = false
        state.error = null
      }
    )

    builder.addCase(deleteExam.pending, (state: ExamState) => {
      state.actionLoading = true
      state.error = null
    })
    builder.addCase(deleteExam.rejected, (state: ExamState, action: PayloadAction<any>) => {
      const {error} = action.payload
      state.error = error
      state.actionLoading = false
    })
    builder.addCase(
      deleteExam.fulfilled,
      (state: ExamState, action: PayloadAction<FetchExamByIdResponse>) => {
        state.examForEdit = action.payload.exam
        state.actionLoading = false
        state.error = null
      }
    )

    builder.addCase(endExam.pending, (state: ExamState) => {
      state.actionLoading = true
      state.error = null
    })
    builder.addCase(endExam.rejected, (state: ExamState, action: PayloadAction<any>) => {
      const {error} = action.payload
      state.error = error
      state.actionLoading = false
    })
    builder.addCase(
      endExam.fulfilled,
      (state: ExamState, action: PayloadAction<FetchExamByIdResponse>) => {
        state.examForEdit = action.payload.exam
        state.actionLoading = false
        state.error = null
      }
    )

    builder.addCase(undoExam.pending, (state: ExamState) => {
      state.actionLoading = true
      state.error = null
    })
    builder.addCase(undoExam.rejected, (state: ExamState, action: PayloadAction<any>) => {
      const {error} = action.payload
      state.error = error
      state.actionLoading = false
    })
    builder.addCase(
      undoExam.fulfilled,
      (state: ExamState, action: PayloadAction<FetchExamByIdResponse>) => {
        state.examForEdit = action.payload.exam
        state.actionLoading = false
        state.error = null
      }
    )
  },
})

export default examSlice.reducer
export const actions = examSlice.actions
